export default function({ route, redirect }) {
    if (route.fullPath === '/pages/home') {
        redirect('/four-hands-art-studio-designer-feature')
    } else if (route.fullPath === '/pages/brands') {
        redirect('/brands')
    }
}